import React, { useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import loadable from "@loadable/component";
import ScrapCarsMetaTags from "../../shared/scrap-cars-meta-tags";
import ScrapCarBanner from "../scrap-car-banner";
import ScrapCarsFaq from "../scrap-cars-faq";
const ScrapCarProcess = loadable(() => import("../scrap-car-process"));
const ScrapCarBenefits = loadable(() => import("../scrap-car-benefits"));
const WhyScrapCar = loadable(() => import("../why-scrap-car"));
const CarScrapPolicy = loadable(() => import("../car-scrap-policy"));
const ScrapCarVehicleDetails = loadable(
    () => import("../scrap-car-vehicle-details"));
const HowScrapCarWork = loadable(() => import("../how-scrap-car-work"));
import { C2B_LEAD_TYPES } from "../../../constants/seller-lead-types";
import { Breadcrumbs } from "@cars24/turbo-web/lib/breadcrumbs";
import { appUrl } from "../../../constants/url-constants";
import { LazyComponent } from "../../shared/lazy-image";
import useC2bCleverTap from "../../../hooks/use-c2b-clevertap";

const ScrapCar = ({
    isSSR,
    fetchDataConnect,
    updateLeadSourceConnect,
    cmsData
}) => {
    useC2bCleverTap("Scrap_car");
    const {
        whycars24 = {},
        carTypeList = [],
        carTypeTitle = "",
        secondaryContentTitle = "",
        secondaryContent = [],
        highlightsTitle = "",
        bannerList = [],
        metaTitle = "",
        metaDescription = "",
        breadcrumb = [],
        heroImageSubTitle = "",
        factTitle = "",
        factList = [],
        heroImageTitle = "",
        heroDesktopImage = {},
        ogTitle = "",
        ogDescription = ""
    } = cmsData || {};

    useEffect(() => {
        updateLeadSourceConnect(C2B_LEAD_TYPES.SCRAP_CAR);
        if (!isSSR) {
            fetchDataConnect();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    return (
        <React.Fragment>
            <ScrapCarsMetaTags
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                ogDescription={ogDescription}
                ogTitle={ogTitle}
            />
            <div styleName="styles.scrapCarBannerWrapper">
                <ScrapCarBanner
                    heading={heroImageTitle}
                    subHeading={heroImageSubTitle}
                    homePageBanner={heroDesktopImage.url}
                    altText={heroDesktopImage.alternativeText}
                />
            </div>

            <div styleName="styles.scrapCarProcessWrapper">
                <LazyComponent>
                    <ScrapCarProcess />
                </LazyComponent>
            </div>

            <div styleName="styles.scrapCarWhyWrapper">
                <LazyComponent>
                    <WhyScrapCar whycars24={whycars24} />
                </LazyComponent>
            </div>

            <div styleName="styles.scrapCarVehicleWrapper">
                <LazyComponent>
                    <ScrapCarVehicleDetails
                        carTypeList={carTypeList}
                        carTypeTitle={carTypeTitle}
                    />
                </LazyComponent>
            </div>
            <div styleName="styles.scrapCarWorkwrapper">
                <LazyComponent>
                    <HowScrapCarWork
                        secondaryContentTitle={secondaryContentTitle}
                        secondaryContent={secondaryContent}
                    />
                </LazyComponent>
            </div>

            <div styleName="styles.scrapCarPolicyWrapper">
                <LazyComponent>
                    <CarScrapPolicy
                        bannerTitle={highlightsTitle}
                        bannerList={bannerList}
                    />
                </LazyComponent>
            </div>
            <div styleName="styles.scrapCarBenefitsWrapper">
                <div  styleName="styles.scrapCarBenefits">
                    <LazyComponent>
                        <ScrapCarBenefits factTitle={factTitle} factList={factList} />
                    </LazyComponent>
                </div>
            </div>
            <div styleName="styles.scrapCarFaqWrapper">
                <ScrapCarsFaq />
            </div>
            <div styleName="styles.breadcrumb">
                <div styleName={"styles.breadcrumbText"}>
                    <Breadcrumbs list={breadcrumb} attachSchema baseUrl={appUrl()} />
                </div>
            </div>
        </React.Fragment>
    );
};

ScrapCar.propTypes = {
    fetchDataConnect: PropTypes.func,
    isSSR: PropTypes.bool,
    updateLeadSourceConnect: PropTypes.func,
    cmsData: PropTypes.object
};

export default ScrapCar;

